import React, { useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import CoHostManager from 'components/CohostManager';
import { isPrimaryHost } from 'utils';
const CoHostButton = ({ classes, presentationId }) => {
  const [open, setOpen] = useState(false);
  
  const handleClick = () => {
    if (!isPrimaryHost()) {
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

//   Only render for hosts
  if (!isPrimaryHost()) {
    return null;
  }

  return (
    <>
      <Tooltip title="Manage Co-Hosts" aria-label="manage-cohosts">
        <IconButton
          onClick={handleClick}
          edge="start"
          color="inherit"
          aria-label="manage-cohosts"
          className={classes.infoButton}
        >
          <GroupAddIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>

      <CoHostManager 
        open={open} 
        onClose={handleClose} 
        presentationId={presentationId}
      />
    </>
  );
};

export default CoHostButton;